import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box, BoxProps, Typography, Stack } from '@mui/material';
import useResponsive from '../../hooks/useResponsive';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  logoTextColor?: string;
  logoBg?: string;
}

export default function Logo({ sx, logoTextColor, logoBg }: Props) {
  const theme = useTheme();
  const smUp = useResponsive('up', 'sm');
  const mdUp = useResponsive('up', 'md');

  const logo = (
    <Stack
      direction="row"
      justifyContent="center"
      alignItems="center"
      spacing={1}
      sx={sx}
    >
      <Box
        component="img"
        src="/favicon/logo.png"
        sx={{ width: 50, background: logoBg, borderRadius: 2 }}
      />
      {mdUp && (
        <Typography color={logoTextColor} variant="h4">
          Diplomade
        </Typography>
      )}
    </Stack>
  );

  return <>{logo}</>;
}
